import React from "react";
import fruit from "../../Assets/images/fruits.png";
import vegetable from "../../Assets/images/vegetable.png";
import meat from "../../Assets/images/meat.png";
import fish from "../../Assets/images/fish.png";
import oil from "../../Assets/images/oil.png";
import snack from "../../Assets/images/snack.png";
import ProductCards from "../ProductCards";
import "./product.scss";

import productCardData from "./../../Data";


const productCard = [
  {
    title: "Fruit",
    img: fruit,
    backgroundColor: "#fad586",
  },
  {
    title: "Vegetables",
    img: vegetable,
    backgroundColor: "#96bb7c",
  },
  {
    title: "Meat",
    img: meat,
    backgroundColor: "#fff700",
  },
  {
    title: "Fish",
    img: fish,
    backgroundColor: "#e48900",
  },
  {
    title: "Oil",
    img: oil,
    backgroundColor: "#96bb7c",
  },
  {
    title: "Snack",
    img: snack,
    backgroundColor: "#fad586",
  },
];



const Product = () => {
  return (
    <section className="product section">
      <div className="container">
        <h1 className="text-center">Products</h1>
        <p className="text-center">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vero,
          corporis.
        </p>

        
        <div className="row my-5">
          {productCard.map((card) => (
            <div className="col-lg-2 col-md-4 col-sm-12 col-xs-12 img-card " data-aos="fade-up">
              <div
                className="product-card"
                style={{ backgroundColor: `${card.backgroundColor}` }}
              >
                <img src={card.img} alt={card.title} />
                <h5>{card.title}</h5>
              </div>
            </div>
          ))}
           </div>
          <div className="row my-5">
            {productCardData.map((product) => (
              <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12 my-3" data-aos="fade-up">
                <ProductCards
                  id={product.id}
                  title={product.title}
                  image={product.img}
                  rating={product.rating}
                  price={product.price}
                />
              </div>
            ))}
          </div>
        </div>
    </section>
  );
};

export default Product;
